import { render, staticRenderFns } from "./ReportsBase.vue?vue&type=template&id=0e7b0b70"
import script from "./ReportsBase.vue?vue&type=script&lang=js"
export * from "./ReportsBase.vue?vue&type=script&lang=js"
import style0 from "./ReportsBase.vue?vue&type=style&index=0&id=0e7b0b70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports